import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, SubmissionError } from 'redux-form'
import { Button, Confirm, Modal } from 'semantic-ui-react'
import { StdCard } from 'components'
import { BLAction } from 'ducks/billform'
import FileInput from './FileInput'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Cont, BottomActionsContainer } from './styled'

const Approve = (props) => {
  const { blDetail = {}, handleSubmit, valueForm } = props
  const sn = blDetail.sn || ''

  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [showAlertGRGood, setShowAlertGRGood] = useState(false)

  function submitValidate(action) {
    setSubmitActionName(action)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
      .then(() => {
        console.log(action)
        if (action.toLowerCase() === 'revise') {
          if (!valueForm.comment) {
            throw new SubmissionError({ comment: ' Required! ' })
          }
        }
        if (action.toLowerCase() !== 'revise' && valueForm.isAlertGrTypeGoods && action !== 'Wait for Original Doc.') {
          setShowAlertGRGood(true)
        } else {
          setShowConfirm(true)
        }
      })
  }

  function submitAction() {
    setShowConfirm(false)
    setShowAlertGRGood(false)
    props.BLAction({
      docId: valueForm.id,
      sn: sn,
      action: submitActionName,
      comment: valueForm.comment,
      title: valueForm.title,
      commentAttachments: valueForm.actionCommentAttachments
    }, props.history)
  }

  return (
    <StdCard title='Action for Approval' highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
      <Cont>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Field
            name='comment'
            label='Your Comment'
            type={type.textArea}
            containerStyle={{ marginRight: '0px' }}
            component={FieldInput} />
          <Field name='actionCommentAttachments' label='Attachments' type={type.file} component={FileInput} />
          <BottomActionsContainer>
            {
              (valueForm.actions || []).length > 0 ?
                valueForm.actions.map((actionKey) => 
                  <Button
                    type='submit'
                    content={actionKey === 'Approve' ? 'Accept' : actionKey}
                    color={
                      actionKey === 'Approve' ? 'green' :
                      actionKey === 'Revise' ? 'orange' : 'yellow'
                    }
                    onClick={handleSubmit(() => submitValidate(actionKey))}
                  />
                ) :
                <React.Fragment>
                  <Button
                    type='submit'
                    content='Accept'
                    color='green'
                    onClick={handleSubmit(() => submitValidate('Approve'))}
                  />
                  <Button
                    type='submit'
                    content='Revise '
                    color=''
                    onClick={handleSubmit(() => submitValidate('Revise'))}
                  />
                </React.Fragment>
            }
          </BottomActionsContainer>
        </div>
        <Confirm
          size='mini'
          open={showConfirm}
          onCancel={() => setShowConfirm(false)}
          onConfirm={() => submitAction()}
        />
        <Modal
          open={showAlertGRGood}
          size='tiny'
          header={<div className="header" style={{ color: '#FFCC00' }}>Warning!</div>}
          content={valueForm && valueForm.grTypeGoodsMessage}
          actions={[
            { key: 'cancel', content: 'Cancel', onClick: () => setShowAlertGRGood(false) },
            { key: 'ok', content: 'OK', positive: true, onClick: () => submitAction() }
          ]}
        />
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formBill')(state),
  })
}

const mapDispatchToProps = {
  BLAction
}

export default connect(mapStateToProps, mapDispatchToProps)(Approve)
